
export const bookedDates = [
  '2025-07-05',
  '2025-07-06',
  '2025-07-12',
  '2025-07-13',
  '2025-07-19',
  '2025-07-26',
  '2025-07-27',
  '2025-08-02',
  '2025-08-09',
  '2025-08-10',
  '2025-08-16',
  '2025-08-23',
  '2025-08-30',
  '2025-08-31',
  '2025-09-06',
  '2025-09-13',
  '2025-09-20',
  '2025-09-27',
];

export const featuredBars = [
  {
    id: 'pb-001',
    name: 'Classic Timber Portable Bar',
    description:
      'Handcrafted from premium Australian hardwood, this bar features a rich timber finish with brass accents. Perfect for rustic weddings and outdoor events in Melbourne.',
    price: 350,
    unit: 'per day',
    dimensions: '2.4m x 0.6m x 1.1m',
    capacity: 'Serves up to 150 guests',
    features: ['Built-in speed rail', 'Adjustable shelving', 'Lockable castors', 'Ice well included'],
    image:
      'https://public.readdy.ai/ai/img_res/c11e14d0d503b0cf82d180174de345be.jpg',
  },
  {
    id: 'pb-002',
    name: 'LED Illuminated Bar',
    description:
      'A show-stopping centrepiece with customisable LED lighting in any colour. Remote-controlled colour changes create the perfect ambiance for corporate events and gala nights.',
    price: 450,
    unit: 'per day',
    dimensions: '2.0m x 0.5m x 1.1m',
    capacity: 'Serves up to 120 guests',
    features: ['16 colour modes', 'Remote controlled', 'Waterproof surface', 'Battery backup'],
    image:
      'https://readdy.ai/api/search-image?query=modern%20LED%20illuminated%20portable%20bar%20counter%20glowing%20warm%20white%20and%20amber%20light%20on%20clean%20white%20background%2C%20premium%20mobile%20cocktail%20bar%20for%20events%2C%20professional%20product%20photography%2C%20sleek%20contemporary%20design%2C%20luxury%20event%20furniture&width=600&height=500&seq=cat-pbar-002&orientation=landscape',
  },
  {
    id: 'pb-003',
    name: 'Rustic Barrel Bar Station',
    description:
      'Authentic reclaimed wine barrels transformed into a charming bar station. Ideal for vineyard weddings, garden parties, and bohemian-themed celebrations across Melbourne.',
    price: 280,
    unit: 'per day',
    dimensions: '1.8m x 0.6m x 1.0m',
    capacity: 'Serves up to 80 guests',
    features: ['Reclaimed oak barrels', 'Natural finish', 'Removable top shelf', 'Lightweight design'],
    image:
      'https://readdy.ai/api/search-image?query=rustic%20wine%20barrel%20converted%20into%20portable%20bar%20station%20on%20clean%20white%20background%2C%20vintage%20event%20bar%2C%20reclaimed%20wood%20barrel%20bar%20with%20serving%20top%2C%20professional%20product%20photography%2C%20warm%20tones%2C%20charming%20rustic%20design&width=600&height=500&seq=cat-pbar-003&orientation=landscape',
  },
  {
    id: 'pb-004',
    name: 'Gold Frame Luxury Bar',
    description:
      'Our signature luxury bar featuring a brushed gold metal frame with Italian marble top. The ultimate statement piece for high-end weddings and VIP corporate functions.',
    price: 520,
    unit: 'per day',
    dimensions: '2.4m x 0.6m x 1.1m',
    capacity: 'Serves up to 200 guests',
    features: ['Italian marble top', 'Brushed gold frame', 'Mirrored back panel', 'Premium ice well'],
    image:
      'https://readdy.ai/api/search-image?query=luxurious%20gold%20metal%20frame%20portable%20bar%20with%20white%20marble%20top%20on%20clean%20white%20background%2C%20premium%20event%20bar%20counter%2C%20elegant%20cocktail%20station%2C%20professional%20product%20photography%2C%20glamorous%20high%20end%20design%2C%20luxury%20event%20furniture&width=600&height=500&seq=cat-pbar-004&orientation=landscape',
  },
  {
    id: 'pb-005',
    name: 'Compact Pop-Up Bar',
    description:
      'Lightweight and versatile, this foldable bar sets up in minutes. Perfect for intimate gatherings, house parties, and smaller Melbourne venues with limited space.',
    price: 180,
    unit: 'per day',
    dimensions: '1.5m x 0.5m x 1.0m',
    capacity: 'Serves up to 50 guests',
    features: ['Folds flat for transport', 'Sets up in 5 minutes', 'Built-in bottle holders', 'Scratch-resistant top'],
    image:
      'https://readdy.ai/api/search-image?query=compact%20foldable%20pop%20up%20bar%20counter%20in%20sleek%20black%20finish%20on%20clean%20white%20background%2C%20portable%20event%20bar%20station%2C%20lightweight%20mobile%20bar%2C%20professional%20product%20photography%2C%20modern%20minimalist%20design%2C%20event%20furniture&width=600&height=500&seq=cat-pbar-005&orientation=landscape',
  },
  {
    id: 'pb-006',
    name: 'Portable Bar Ice Cooler',
    description:
      'Keep your beverages perfectly chilled with our insulated portable bar ice cooler. Stainless steel construction with built-in drain, ideal for cocktail stations, outdoor events, and Melbourne summer parties.',
    price: 65,
    unit: 'per day',
    dimensions: '1.0m x 0.5m x 0.9m',
    capacity: 'Holds up to 60 bottles',
    features: ['Insulated stainless steel', 'Built-in drain valve', 'Lockable castors', 'Removable dividers'],
    image:
      'https://readdy.ai/api/search-image?query=portable%20bar%20ice%20cooler%20insulated%20stainless%20steel%20tub%20with%20drain%20on%20clean%20white%20background%2C%20premium%20event%20ice%20bucket%20cooler%20for%20drinks%20and%20bottles%2C%20professional%20product%20photography%2C%20sleek%20modern%20design%2C%20simple%20studio%20lighting%2C%20luxury%20event%20equipment&width=600&height=500&seq=cat-pbar-006&orientation=landscape',
  },
];

export const barMatsAccessories = [
  {
    id: 'bm-001',
    name: 'Premium Rubber Bar Mat',
    description:
      'Professional-grade rubber bar mat with drainage channels. Anti-slip surface keeps your bar area clean and safe during service.',
    price: 8,
    unit: 'per mat/day',
    minQty: 5,
    dimensions: '45cm x 30cm',
    image:
      'https://readdy.ai/api/search-image?query=premium%20black%20rubber%20bar%20service%20mat%20with%20drainage%20holes%20on%20clean%20white%20background%2C%20professional%20bartender%20bar%20mat%2C%20non-slip%20surface%2C%20product%20photography%2C%20simple%20studio%20lighting%2C%20bar%20accessory&width=400&height=400&seq=cat-bmat-001&orientation=squarish',
  },
  {
    id: 'bm-002',
    name: 'Custom Branded Bar Runner',
    description:
      'Elegant bar runner with gold trim, available for custom branding. Makes your bar setup look polished and professional.',
    price: 15,
    unit: 'per runner/day',
    minQty: 3,
    dimensions: '60cm x 10cm',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20custom%20branded%20bar%20runner%20mat%20in%20black%20with%20gold%20trim%20on%20clean%20white%20background%2C%20premium%20bar%20counter%20runner%2C%20professional%20bartending%20accessory%2C%20product%20photography%2C%20luxury%20bar%20equipment&width=400&height=400&seq=cat-bmat-002&orientation=squarish',
  },
  {
    id: 'bm-003',
    name: 'Silicone Drip Mat Set',
    description:
      'Food-grade silicone drip mats that catch spills and condensation. Easy to clean and dishwasher safe.',
    price: 6,
    unit: 'per set/day',
    minQty: 10,
    dimensions: '30cm x 20cm each',
    image:
      'https://readdy.ai/api/search-image?query=set%20of%20silicone%20drip%20mats%20for%20cocktail%20bar%20in%20dark%20grey%20on%20clean%20white%20background%2C%20professional%20bar%20accessories%2C%20drink%20coaster%20mats%2C%20product%20photography%2C%20simple%20studio%20lighting%2C%20bar%20equipment&width=400&height=400&seq=cat-bmat-003&orientation=squarish',
  },
  {
    id: 'bm-004',
    name: 'Bar Caddy Organiser',
    description:
      'Multi-compartment caddy for napkins, straws, stirrers and garnishes. Keeps your bar station tidy and efficient.',
    price: 12,
    unit: 'per unit/day',
    minQty: 2,
    dimensions: '25cm x 15cm x 12cm',
    image:
      'https://readdy.ai/api/search-image?query=professional%20bar%20caddy%20napkin%20and%20straw%20organiser%20in%20black%20on%20clean%20white%20background%2C%20bartender%20station%20organiser%2C%20cocktail%20bar%20accessory%2C%20product%20photography%2C%20simple%20studio%20lighting%2C%20bar%20equipment&width=400&height=400&seq=cat-bmat-004&orientation=squarish',
  },
  {
    id: 'bm-005',
    name: 'Ice Well Bar Mat',
    description:
      'Integrated ice well with surrounding rubber mat. Keeps ice accessible while protecting your bar surface from water damage.',
    price: 18,
    unit: 'per unit/day',
    minQty: 2,
    dimensions: '50cm x 35cm',
    image:
      'https://readdy.ai/api/search-image?query=professional%20ice%20well%20insert%20with%20surrounding%20rubber%20bar%20mat%20on%20clean%20white%20background%2C%20bartender%20ice%20station%2C%20cocktail%20bar%20equipment%2C%20product%20photography%2C%20simple%20studio%20lighting%2C%20premium%20bar%20accessory&width=400&height=400&seq=cat-bmat-005&orientation=squarish',
  },
  {
    id: 'bm-006',
    name: 'Speed Rail Attachment',
    description:
      'Stainless steel speed rail that attaches to any of our portable bars. Holds up to 12 bottles for quick service.',
    price: 22,
    unit: 'per unit/day',
    minQty: 1,
    dimensions: '80cm x 10cm',
    image:
      'https://readdy.ai/api/search-image?query=stainless%20steel%20speed%20rail%20bottle%20holder%20for%20bar%20on%20clean%20white%20background%2C%20professional%20bartender%20speed%20rack%2C%20cocktail%20bar%20equipment%2C%20product%20photography%2C%20simple%20studio%20lighting%2C%20premium%20bar%20accessory&width=400&height=400&seq=cat-bmat-006&orientation=squarish',
  },
];

export const consumables = [
  {
    id: 'con-001',
    name: 'Ice 5kg Bag',
    description:
      'Premium crystal-clear ice cubes in a convenient 5kg bag. Perfect for cocktail stations, beverage service, and keeping drinks chilled at any event. Order multiple bags for larger gatherings.',
    price: 7,
    unit: 'per unit',
    minQty: 1,
    image:
      'https://readdy.ai/api/search-image?query=five%20kilogram%20bag%20of%20premium%20crystal%20clear%20ice%20cubes%20in%20clear%20packaging%20on%20clean%20white%20background%2C%20party%20ice%20for%20events%20cocktails%20and%20beverages%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20cold%20refreshing%20look&width=400&height=400&seq=cat-con-001&orientation=squarish',
  },
];

export const partyGlassware = [
  {
    id: 'pg-001',
    name: 'Wine Glasses',
    description: 'Elegant stemmed wine glasses perfect for red or white wine service at any event. Available in standard crystal and acrylic options.',
    price: 1.50,
    unit: 'per glass/day',
    minQty: 20,
    tag: 'Crystal & Acrylic',
    image: 'https://readdy.ai/api/search-image?query=elegant%20clear%20wine%20glass%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20crystal%20stemware%20for%20parties%20and%20events%2C%20minimalist%20style&width=400&height=400&seq=pg-wine-001&orientation=squarish',
  },
  {
    id: 'pg-002',
    name: 'Champagne Flutes',
    description: 'Tall, slender flutes designed to preserve bubbles and showcase sparkling wines. Ideal for toasts, weddings, and celebrations.',
    price: 1.50,
    unit: 'per flute/day',
    minQty: 20,
    tag: 'Crystal & Acrylic',
    image: 'https://readdy.ai/api/search-image?query=elegant%20champagne%20flute%20glass%20on%20clean%20white%20background%2C%20premium%20sparkling%20wine%20glass%20for%20events%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20crystal%20stemware%20for%20celebrations%20and%20weddings%2C%20minimalist%20style&width=400&height=400&seq=pg-flute-001&orientation=squarish',
  },
  {
    id: 'pg-003',
    name: 'Hi-ball Glasses',
    description: 'Tall straight-sided glasses perfect for cocktails, mocktails, soft drinks, and mixed beverages. A versatile staple for any bar setup.',
    price: 1.50,
    unit: 'per glass/day',
    minQty: 20,
    tag: 'Crystal & Acrylic',
    image: 'https://readdy.ai/api/search-image?query=tall%20clear%20hiball%20glass%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20crystal%20tumbler%20for%20cocktails%20and%20mixed%20drinks%2C%20minimalist%20style&width=400&height=400&seq=pg-hiball-001&orientation=squarish',
  },
  {
    id: 'pg-004',
    name: 'Rocks Glasses',
    description: 'Short, sturdy tumblers ideal for spirits on the rocks, whiskey, and short cocktails. Classic and timeless for any event bar.',
    price: 1.50,
    unit: 'per glass/day',
    minQty: 20,
    tag: 'Crystal & Acrylic',
    image: 'https://readdy.ai/api/search-image?query=short%20rocks%20glass%20old%20fashioned%20tumbler%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20crystal%20whiskey%20glass%20for%20parties%2C%20minimalist%20style&width=400&height=400&seq=pg-rocks-001&orientation=squarish',
  },
  {
    id: 'pg-005',
    name: 'Cocktail Glasses',
    description: 'Classic V-shaped martini and coupe cocktail glasses for serving signature drinks. Makes every cocktail look stunning.',
    price: 1.50,
    unit: 'per glass/day',
    minQty: 20,
    tag: 'Crystal & Acrylic',
    image: 'https://readdy.ai/api/search-image?query=classic%20martini%20cocktail%20glass%20on%20clean%20white%20background%2C%20premium%20event%20glassware%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20crystal%20stemware%20for%20cocktail%20parties%2C%20minimalist%20style&width=400&height=400&seq=pg-cocktail-001&orientation=squarish',
  },
  {
    id: 'pg-006',
    name: 'Acrylic Glasses',
    description: 'Shatterproof acrylic versions of all our glassware styles. Perfect for outdoor events, pool parties, and venues where glass is not permitted.',
    price: 1.00,
    unit: 'per glass/day',
    minQty: 1,
    tag: 'Shatterproof',
    image: 'https://readdy.ai/api/search-image?query=clear%20acrylic%20shatterproof%20glasses%20set%20on%20clean%20white%20background%2C%20premium%20unbreakable%20event%20glassware%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20plastic%20stemware%20for%20outdoor%20parties%2C%20minimalist%20style&width=400&height=400&seq=pg-acrylic-001&orientation=squarish',
  },
];

export const partyTables = [
  {
    id: 'pt-001',
    name: 'Ice Cooler Tables',
    description: 'Insulated table-top coolers that keep beverages chilled throughout your event. Perfect for self-serve drink stations and outdoor parties.',
    price: 85,
    unit: 'per table/day',
    minQty: 1,
    dimensions: 'Various sizes available',
    image: 'https://readdy.ai/api/search-image?query=insulated%20ice%20cooler%20table%20for%20events%20on%20clean%20white%20background%2C%20premium%20party%20rental%20table%20with%20built-in%20ice%20well%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20outdoor%20event%20furniture%2C%20minimalist%20style&width=400&height=400&seq=pt-ice-001&orientation=squarish',
  },
  {
    id: 'pt-002',
    name: '4-Foot Trestle Tables',
    description: 'Compact and versatile 4-foot folding trestle tables. Great for smaller setups, gift tables, cake tables, and registration desks.',
    price: 25,
    unit: 'per table/day',
    minQty: 1,
    dimensions: '120cm x 60cm',
    image: 'https://readdy.ai/api/search-image?query=clean%20white%204%20foot%20folding%20trestle%20table%20on%20clean%20white%20background%2C%20premium%20party%20rental%20furniture%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20event%20table%20hire%2C%20minimalist%20style&width=400&height=400&seq=pt-4ft-001&orientation=squarish',
  },
  {
    id: 'pt-003',
    name: '6-Foot Trestle Tables',
    description: 'Full-size 6-foot folding trestle tables ideal for buffets, grazing tables, display setups, and large event layouts.',
    price: 35,
    unit: 'per table/day',
    minQty: 1,
    dimensions: '180cm x 75cm',
    image: 'https://readdy.ai/api/search-image?query=clean%20white%206%20foot%20folding%20trestle%20table%20on%20clean%20white%20background%2C%20premium%20party%20rental%20furniture%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20event%20buffet%20table%20hire%2C%20minimalist%20style&width=400&height=400&seq=pt-6ft-001&orientation=squarish',
  },
  {
    id: 'pt-004',
    name: 'Stretch Tablecloths',
    description: 'Premium fitted stretch tablecloths that give your tables a sleek, polished look. Available in white, black, and ivory to suit any theme.',
    price: 12,
    unit: 'per cloth/day',
    minQty: 5,
    dimensions: 'Fits 4ft & 6ft tables',
    image: 'https://readdy.ai/api/search-image?query=elegant%20white%20stretch%20tablecloth%20fitted%20on%20trestle%20table%20on%20clean%20white%20background%2C%20premium%20event%20linen%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20party%20table%20cover%2C%20minimalist%20style&width=400&height=400&seq=pt-cloth-001&orientation=squarish',
  },
];

export const displayBoards = [
  {
    id: 'db-001',
    name: 'Display Folder Boards',
    description: 'Professional A-frame and standing display folder boards for menus, seating charts, welcome signs, and event programs. Elegant and easy to set up.',
    price: 30,
    unit: 'per board/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20gold%20frame%20display%20folder%20board%20standing%20on%20clean%20white%20background%2C%20premium%20event%20signage%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20wedding%20menu%20display%20stand%2C%20minimalist%20style&width=400&height=400&seq=db-folder-001&orientation=squarish',
  },
  {
    id: 'db-002',
    name: 'Partition Dividers',
    description: 'Freestanding partition dividers to section off areas, create privacy, or add a decorative backdrop. Available in various finishes to match your event style.',
    price: 75,
    unit: 'per panel/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20white%20freestanding%20partition%20divider%20panel%20on%20clean%20white%20background%2C%20premium%20event%20room%20divider%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20decorative%20backdrop%20panel%20for%20events%2C%20minimalist%20style&width=400&height=400&seq=db-partition-001&orientation=squarish',
  },
];

export const partyHelpers = [
  {
    id: 'ph-001',
    name: 'Ice Buckets',
    description: 'Stylish stainless steel and acrylic ice buckets for chilling wine, champagne, and spirits at the table. Available in various sizes.',
    price: 10,
    unit: 'per bucket/day',
    minQty: 5,
    image: 'https://readdy.ai/api/search-image?query=elegant%20stainless%20steel%20ice%20bucket%20on%20clean%20white%20background%2C%20premium%20event%20bar%20accessory%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20champagne%20wine%20chiller%20for%20parties%2C%20minimalist%20style&width=400&height=400&seq=ph-icebucket-001&orientation=squarish',
  },
  {
    id: 'ph-002',
    name: 'Punch Bowls',
    description: 'Large glass and acrylic punch bowls with ladles for serving signature cocktails, mocktails, and fruit punches to groups. A beautiful centrepiece for any drinks station.',
    price: 20,
    unit: 'per bowl/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=large%20clear%20glass%20punch%20bowl%20with%20ladle%20on%20clean%20white%20background%2C%20premium%20event%20party%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20drinks%20serving%20bowl%20for%20parties%20and%20events%2C%20minimalist%20style&width=400&height=400&seq=ph-punch-001&orientation=squarish',
  },
  {
    id: 'ph-003',
    name: 'Beverage Dispensers',
    description: 'Large-capacity glass and acrylic beverage dispensers with taps for self-serve drinks stations. Perfect for infused water, lemonade, cocktails, and iced teas.',
    price: 25,
    unit: 'per dispenser/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=clear%20glass%20beverage%20dispenser%20with%20tap%20on%20clean%20white%20background%2C%20premium%20event%20drinks%20station%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20self%20serve%20drink%20dispenser%20for%20parties%2C%20minimalist%20style&width=400&height=400&seq=ph-dispenser-001&orientation=squarish',
  },
  {
    id: 'ph-004',
    name: 'Water Bottles',
    description: 'Premium branded water bottles for guest tables and event stations. Available in still and sparkling options, delivered chilled and ready to serve.',
    price: 3,
    unit: 'per bottle',
    minQty: 24,
    image: 'https://readdy.ai/api/search-image?query=elegant%20glass%20water%20bottle%20on%20clean%20white%20background%2C%20premium%20event%20water%20bottle%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20still%20water%20for%20event%20tables%20and%20guests%2C%20minimalist%20style&width=400&height=400&seq=ph-water-001&orientation=squarish',
  },
  {
    id: 'ph-005',
    name: 'Grazing Table Stands & Bowls',
    description: 'Tiered stands, risers, and serving bowls to create stunning grazing table displays. Mix heights and textures for a visually impressive food presentation.',
    price: 45,
    unit: 'per set/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20tiered%20grazing%20table%20stands%20and%20serving%20bowls%20on%20clean%20white%20background%2C%20premium%20event%20food%20display%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20charcuterie%20board%20risers%20for%20parties%2C%20minimalist%20style&width=400&height=400&seq=ph-grazing-001&orientation=squarish',
  },
  {
    id: 'ph-006',
    name: 'Cheese Boards & Knives',
    description: 'Beautiful marble, slate, and timber cheese boards paired with professional cheese knives. Perfect for grazing tables, cocktail parties, and intimate gatherings.',
    price: 30,
    unit: 'per set/day',
    minQty: 1,
    image: 'https://readdy.ai/api/search-image?query=elegant%20marble%20and%20timber%20cheese%20board%20with%20cheese%20knives%20on%20clean%20white%20background%2C%20premium%20event%20charcuterie%20board%20hire%2C%20professional%20product%20photography%2C%20simple%20studio%20lighting%2C%20grazing%20table%20accessories%20for%20parties%2C%20minimalist%20style&width=400&height=400&seq=ph-cheese-001&orientation=squarish',
  },
];

export const testimonials = [
  {
    name: 'Sarah Mitchell',
    event: 'Wedding Reception',
    location: 'Yarra Valley, Melbourne',
    text: 'The Gold Frame Bar was the centrepiece of our wedding. Every guest commented on how stunning it looked. House of FMR made the whole process seamless.',
    rating: 5,
  },
  {
    name: 'James Chen',
    event: 'Corporate Gala',
    location: 'Crown Melbourne',
    text: 'We hired the LED bar and bar mats for our annual gala. The colour-changing feature was a huge hit. Professional setup and pickup — highly recommend.',
    rating: 5,
  },
  {
    name: 'Emily Rodriguez',
    event: 'Garden Party',
    location: 'Brighton, Melbourne',
    text: 'The Rustic Barrel Bar was perfect for our garden party theme. Delivery was on time and the team was incredibly helpful with setup advice.',
    rating: 5,
  },
];
